import { render, staticRenderFns } from "./ConversationMergeModal.vue?vue&type=template&id=06ef78f0&scoped=true&"
import script from "./ConversationMergeModal.vue?vue&type=script&lang=js&"
export * from "./ConversationMergeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ef78f0",
  null
  
)

export default component.exports